import { render, staticRenderFns } from "./TypeWorkPage.vue?vue&type=template&id=579a6de9&"
import script from "./TypeWorkPage.vue?vue&type=script&lang=ts&"
export * from "./TypeWorkPage.vue?vue&type=script&lang=ts&"
import style0 from "./TypeWorkPage.vue?vue&type=style&index=0&id=579a6de9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports